import generalUpload from "../_section/upload.class";

export class userHomeInsuranceUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}

const template = {
    items: [
        {
            name: 'customerNames',
            label: 'Customer Names',
            type: 'text',
        },
        {
            name: 'propertyAddress',
            label: 'Property Address',
            type: 'text',
        },
        {
            name: 'sumInsured',
            label: 'Sum Insured',
            type: 'currency',
        }, {
            name: 'bankName',
            label: 'Bank Name',
            type: 'select',
            options: [
                {label: 'Choose', value: ''},
                {label: 'Bank of Ireland', value: 'boi'},
                {label: 'Haven', value: 'haven'},
                {label: 'PTSB', value: 'ptsb'},
                {label: 'Avent', value:'avant'},
                {label: 'Nua', value: 'nua'},
                {label: 'ICS', value: 'ics'}
            ]
        },
        {
            name: 'startDate',
            label: 'Policy Start Date',
            type: 'date',
        }
    ]
}

export class adminHomeInsuranceUpload extends userHomeInsuranceUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.startDate) {
            this.setDateData({
                dated: this.values.startDate,
                expires: this.values.startDate.add(1, 'year'),
            })
        }
    }
}
